module.exports = __webpack_public_path__ + "img/review1.c262eb5c.png";